import { Routes, Route } from 'react-router-dom'
import { paths } from 'utils'

import { MainPage } from 'pages'
import { ICDPage, ICPCPage, NKPKPage, PHBUPage } from 'pages/Clinical'
import {
	AnatomiskPage,
	NorpatPage,
	ProvematerialePage,
	TekstligeResultatverdierPage,
	NLKPage,
	UndersokelsesmetodePage,
} from 'pages/Lab'
import { AdmPage, SnomedCTPage } from 'pages/Other'
import PageNotFound from 'pages/PageNotFound'
import GeneralSearchResults from 'pages/GeneralSearchResults'
import GeneralSearchTestResults from 'pages/GeneralSearchTestResults'
import KISSearchWithFilter, {
	KISSearchWithFilterTestVersion,
} from 'components/search/buckets/KISSearchWithFilter'
import { CodeSystem } from 'context/elasticsearch/types'

const codeValue = 'codeValue'
const view = 'view'
const environment = process.env.REACT_APP_ENVIRONMENT

const Router = () => {
	return (
		<Routes>
			<Route path={paths.main} index element={<MainPage />} />

			<Route path='*' element={<PageNotFound />} />

			{/* Kliniske kodeverk */}
			<Route
				path={paths.icd10}
				element={<KISSearchWithFilter codeSystem={CodeSystem.Icd10} />}
			>
				<Route
					path={`:${view}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Icd10} />}
				/>
				<Route
					path={`:${view}/:${codeValue}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Icd10} />}
				/>
			</Route>
			{environment === 'dev' && (
				<>
					<Route
						path={`${paths.icd10}/testside/`}
						element={
							<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icd10} />
						}
					>
						<Route
							path={`:${view}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icd10} />
							}
						/>
						<Route
							path={`:${view}/:${codeValue}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icd10} />
							}
						/>
					</Route>
					<Route
						path={`${paths.adm}/testside/`}
						element={
							<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Adm} />
						}
					>
						<Route
							path={`:${view}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Adm} />
							}
						/>
						<Route
							path={`:${view}/:${codeValue}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Adm} />
							}
						/>
					</Route>
					<Route
						path={`${paths.icpc2}/testside/`}
						element={
							<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icpc2} />
						}
					>
						<Route
							path={`:${view}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icpc2} />
							}
						/>
						<Route
							path={`:${view}/:${codeValue}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Icpc2} />
							}
						/>
					</Route>
					<Route
						path={`${paths.norpat}/testside/`}
						element={
							<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Norpat} />
						}
					>
						<Route
							path={`:${view}`}
							element={
								<KISSearchWithFilterTestVersion
									codeSystem={CodeSystem.Norpat}
								/>
							}
						/>
						<Route
							path={`:${view}/:${codeValue}`}
							element={
								<KISSearchWithFilterTestVersion
									codeSystem={CodeSystem.Norpat}
								/>
							}
						/>
					</Route>
					<Route
						path={`${paths.nkpk}/testside/`}
						element={
							<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Nkpk} />
						}
					>
						<Route
							path={`:${view}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Nkpk} />
							}
						/>
						<Route
							path={`:${view}/:${codeValue}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Nkpk} />
							}
						/>
					</Route>
					<Route
						path={`${paths.phbu}/testside/`}
						element={
							<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Phbu} />
						}
					>
						<Route
							path={`:${view}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Phbu} />
							}
						/>
						<Route
							path={`:${view}/:${codeValue}`}
							element={
								<KISSearchWithFilterTestVersion codeSystem={CodeSystem.Phbu} />
							}
						/>
					</Route>
				</>
			)}

			<Route
				path={paths.icpc2}
				element={<KISSearchWithFilter codeSystem={CodeSystem.Icpc2} />}
			>
				<Route
					path={`:${view}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Icpc2} />}
				/>
				<Route
					path={`:${view}/:${codeValue}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Icpc2} />}
				/>
			</Route>
			<Route
				path={paths.nkpk}
				element={<KISSearchWithFilter codeSystem={CodeSystem.Nkpk} />}
			>
				<Route
					path={`:${view}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Nkpk} />}
				/>
				<Route
					path={`:${view}/:${codeValue}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Nkpk} />}
				/>
			</Route>
			<Route
				path={paths.phbu}
				element={<KISSearchWithFilter codeSystem={CodeSystem.Phbu} />}
			>
				<Route
					path={`:${view}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Phbu} />}
				/>
				<Route
					path={`:${view}/:${codeValue}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Phbu} />}
				/>
			</Route>

			{/* Lab kodeverk */}
			<Route
				path={paths.norpat}
				element={<KISSearchWithFilter codeSystem={CodeSystem.Norpat} />}
			>
				<Route
					path={`:${view}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Norpat} />}
				/>
				<Route
					path={`:${view}/:${codeValue}`}
					element={<KISSearchWithFilter codeSystem={CodeSystem.Norpat} />}
				/>
			</Route>
			<Route path={paths.nlk} element={<NLKPage />}>
				<Route path={`:${codeValue}`} element={<NLKPage />} />
			</Route>
			<Route path={paths.anatomisk} element={<AnatomiskPage />}>
				<Route path={`:${codeValue}`} element={<AnatomiskPage />} />
			</Route>
			<Route
				path={paths.tekstligeresultatverdier}
				element={<TekstligeResultatverdierPage />}
			>
				<Route
					path={`:${codeValue}`}
					element={<TekstligeResultatverdierPage />}
				/>
			</Route>
			<Route
				path={paths.undersokelsesmetode}
				element={<UndersokelsesmetodePage />}
			>
				<Route path={`:${codeValue}`} element={<UndersokelsesmetodePage />} />
			</Route>
			<Route path={paths.provemateriale} element={<ProvematerialePage />}>
				<Route path={`:${codeValue}`} element={<ProvematerialePage />} />
			</Route>

			{/* Annet */}
			<Route path={paths.snomed} element={<SnomedCTPage />}>
				<Route path={`:${view}`} element={<SnomedCTPage />} />
				<Route path={`:${view}/:${codeValue}`} element={<SnomedCTPage />} />
			</Route>

			<Route path={`${paths.adm}/`} element={<AdmPage />}>
				<Route path={`:${view}`} element={<AdmPage />} />
				<Route path={`:${view}/:${codeValue}`} element={<AdmPage />} />
			</Route>
			<Route path={`${paths.result}/`} element={<GeneralSearchResults />}>
				<Route path={`:${codeValue}`} element={<GeneralSearchResults />} />
			</Route>
			<Route
				path={`soketestforsynonymer/`}
				element={<GeneralSearchTestResults />}
			>
				<Route path={`:${codeValue}`} element={<GeneralSearchTestResults />} />
			</Route>
		</Routes>
	)
}

export default Router
